require.register("app/restaurant/show/SupplierTab", function(exports, require, module){
  $0
  
});

